import React, { lazy, Suspense } from "react";
import $ from "jquery";
import LazyLoad from 'react-lazyload';

import ButtomService from "../components/buttom_services";
import Clients from "../components/clients";
import Service from "../components/services";

import imageBgMobile from '../assets/images/3d-print-design.webp'
import imageWeb from '../assets/images/web.webp'
import imageBranding from '../assets/images/branding.webp'
import image3D from '../assets/images/slide-3d.webp'
import imageConcepArt from '../assets/images/concept-art.webp'

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mobile: true };
  }

  componentDidMount() {
    this.GoSectionHash();
    window.scrollTo(0, 0);
    $("body").addClass("home");

    if ($(document).width() < 769) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  }

  /*-------------------------------------------------------------------------------*/
  // Go Section Animation
  /*-------------------------------------------------------------------------------*/

  GoSectionHash() {
    let URLhash = window.location.hash;
    let hHeader = 60;
    if (URLhash) {
      let scrollTopSection = $(URLhash).offset().top;
      $("html, body").animate(
        { scrollTop: scrollTopSection - hHeader },
        "fast"
      );
    }
  }

  render() {
    const mobile = this.state.mobile;

    return (
      <>
        <div class="bg-mobile">
          {mobile && (
            <img src={imageBgMobile} alt="Diseño 3D" />
          )}
        </div>
        <div className="slider-wrapper slide-home | m-0 | hover-slide">
          <div className="container-fluid d-flex align-items-end">
            <div className="row">
              <div className="col-lg-9 col-xl-7 z5 mt-5 pt-5 mb-lg-5">
                <h1 className="title | scale-t1 scale-md-t4 scale-xl-t6 | mb-0">
                  Soy Alejandro, diseñador y desarrollador web. Me especializo
                  en crear experiencias digitales únicas con enfoque en{" "}
                  <b className="text-web">UX/UI</b>,{" "}
                  <b className="text-layout">Desarrollo Web</b>,{" "}
                  <b className="text-3d">Animación 3D</b>.
                </h1>

                <div className="d-flex">
                  <div className="buttom btn-quote mt-5 d-inline">
                    Hablemos de tu proyecto
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="services" className="services-icons | align-self-end | my-5">
            <div className="container-fluid">
              <div className="row d-flex flex-nowrap navigation-services align-items-center gap-4">
                <ButtomService
                  service="web"
                  title="Diseño UX UI"
                  serviceNumber="1"
                />

                <ButtomService
                  service="branding"
                  title="Diseño de Marca"
                  serviceNumber="4"
                />

                <ButtomService
                  service="3d"
                  title="Diseño 3D"
                  serviceNumber="2"
                />

                {/* <ButtomService 
									service = "art"
									title = "ARTE CONCEPTUAL"
									serviceNumber = "3"
								/> */}
              </div>
            </div>
          </div>

          <div className="slide-video">
            <div className="slide patern-video"></div>
            {!mobile && (
              <>
                <div className="slide-web itemSlide slide slide1">
                  <img className="lazy" src={imageWeb} alt="Diseño UX UI"  />
                </div>
                <div className="slide-branding itemSlide slide slide2">
                  <LazyLoad height={200} offset={100}>
                    <img src={imageBranding} alt="Diseño de Marca" />
                  </LazyLoad>
                </div>
                <div className="slide-animation itemSlide slide slide3">
                  <LazyLoad height={200} offset={100}>
                    <img src={image3D} alt="Diseño 3D" />
                  </LazyLoad>
                </div>
                <div className="slide-concept itemSlide slide slide4">
                  <LazyLoad height={200} offset={100}>
                    <img src={imageConcepArt} alt="Arte Conceptual" />
                  </LazyLoad>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="container-fluid  home bg-overlay-site position-relative z2 overflow-hidden pt-5">
          <article id="whatIDo">
            <h2 className="title text-center mt-3 mb-3 text-white">Qué hago</h2>
            <div className="row">
              <b className="text-center text-white pb-3 col-md-9 mx-auto">
                Transformo ideas en experiencias digitales que combinan diseño, tecnología y propósito.
              </b>
              <p className="text-center pb-4 mb-5 col-md-9 mx-auto">
                Diseño, estructuro y desarrollo interfaces y sistemas digitales escalables, con foco en UX/UI, diseño web, design systems y animación 3D. Mi trabajo prioriza la performance, accesibilidad y consistencia visual, asegurando experiencias optimizadas y de alto impacto en cualquier entorno digital.
              </p>
            </div>
          </article>
          <section className="container-services">
              <Service
                service="web"
                classPoint="web"
                titleService="Diseño UX UI"
                descriptionService="<b class='text-web'>Diseño centrado en las personas.</b> Trabajo con un enfoque UX/UI que busca no solo la funcionalidad, sino también despertar emociones positivas en el usuario. Cada sitio que diseño está pensado para ofrecer una experiencia clara, fluida y agradable, que conecte con quienes lo usan desde el primer clic."
                textLinkService="Mira lo que he creado"
                categoryService="<b class='badge badge--web'>UX UI</b> <b class='badge badge--layout'>Maquetación</b> <b class='badge badge--system'>Sistema de Diseño</b>"
                link="fendi-chateau"
                invert={false}
              />

              <Service
                service="branding"
                classPoint="branding"
                titleService="Diseño de Marca"
                descriptionService="<b class='text-branding'>Doy forma a la identidad de tu marca.</b> Trabajo con disciplina y atención al detalle para descubrir la esencia de cada proyecto. Mi objetivo es transformar esa identidad en una presencia visual coherente, memorable y relevante en el mercado."
                textLinkService="Mira lo que he creado"
                categoryService="<b class='badge badge--branding'>Branding</b> <b class='badge badge--web'>UX UI</b>"
                link="cafe-de-nohelia"
                invert={true}
              />

              <Service
                service="cube"
                classPoint="animation-3d"
                titleService="Diseño 3D"
                descriptionService="<b class='text-3d'>Doy vida a tus ideas en 3D.</b> Cada personaje, producto o escenario tiene una historia que contar. Mi trabajo consiste en entender esa historia y convertirla en una experiencia tridimensional impactante. Desde el modelado hasta la animación, me encargo de que cada proyecto cobre vida con detalle, intención y emoción."
                textLinkService="Mira lo que he creado"
                categoryService="<b class='badge badge--concept'>Concept Art</b> <b class='badge badge--3d'>3D Model</b> <b class='badge badge--animation'>3D Animation</b>"
                link="wake-up"
              />

              <Service
                service="concept-art"
                classPoint="concept-art"
                titleService="Arte Conceptual"
                descriptionService="<b class='text-concept'>Dirección visual que transforma ideas en mundos épicos.</b> Desde películas animadas hasta videojuegos, puedo ayudarte a definir el estilo visual de tu proyecto. Trabajo para que cada escena, personaje o entorno tenga una identidad fuerte y coherente, alineada con la historia que quieres contar. Si tienes una visión, yo te ayudo a darle forma visual. ¡Hagámoslo realidad!"
                textLinkService="Mira lo que he creado"
                categoryService="<b class='badge badge--concept'>ART key</b> <b class='badge badge--3d'>Character</b>"
                invert={true}
                mobile={mobile}
                link="/"
              />
          </section>
          <Clients classPoint="clients" />
        </div>
      </>
    );
  }
}

export default Home;
